import { render, staticRenderFns } from "./AccountsHometax.vue?vue&type=template&id=129d3123&"
import script from "./AccountsHometax.vue?vue&type=script&lang=js&"
export * from "./AccountsHometax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports